import React, {Suspense} from 'react';
import {render} from 'react-dom';

import NavFooter from "../../../components/nav-footer";

// Renders components
if (document.getElementById('app-footer') !== null) {
    render(<NavFooter/>, document.getElementById('app-footer'));
}
